import request from 'assets/js/http';

//上会项目评价列表
export function qualityList(data) {
  return request({
    url: '/quality/list',
    method: 'post',
    data
  });
}

//品质表一键催收
export function qualityCollection(data) {
  return request({
    url: '/quality/oneClickCollection',
    method: 'post',
    data
  });
}

//申请上会待评价项目
export function unCreateList(data) {
  return request({
    url: '/quality/unCreateList',
    method: 'post',
    data
  });
}

//品质表不再显示
export function hideQuality(data) {
  return request({
    url: '/quality/hide',
    method: 'post',
    data
  });
}

//运营组创建品质评价表
export function createQualityTable(data) {
  return request({
    url: '/quality/create',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

//提交品质表打分组合
export function createScoreGroup(data) {
  return request({
    url: '/quality/createScoreGroup',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data
  });
}

//各个部门leader信息
export function departments(data) {
  return request({
    url: '/quality/departments',
    method: 'post',
    data
  });
}

//查询本项目所有待评价人员
export function queryAllMember(data) {
  return request({
    url: '/quality/queryAllMember',
    method: 'post',
    data
  });
}
